export const products = [
  {
    name: "aimovig",
    logo: "aimovig.svg",
    questionnaire: ["Residency", "HouseholdSize", "IncomeLevel", "Coverage"],
    group: 3,
    hidden: [],
    householdIncomeQuestion: 2,
    eligibleIncomeGuide: 3
  },
  {
    name: "aranesp",
    logo: "aranesp.svg",
    questionnaire: ["Residency", "HouseholdSize", "IncomeLevel", "Insurance"],
    group: 0,
    hidden: [],
    householdIncomeQuestion: 1,
    eligibleIncomeGuide: 5
  },
  {
    name: "blincyto",
    logo: "blincyto.svg",
    questionnaire: ["Residency", "HouseholdSize", "IncomeLevel", "Insurance"],
    group: 0,
    hidden: [],
    householdIncomeQuestion: 1,
    eligibleIncomeGuide: 5
  },
  {
    name: "enbrel",
    logo: "enbrel.svg",
    questionnaire: ["Returning", "Residency", "HouseholdSize", "IncomeLevel", "Insurance", "Coverage"],
    group: 3,
    hidden: [],
    householdIncomeQuestion: 2,
    eligibleIncomeGuide: 3
  },
  {
    name: "evenity",
    logo: "evenity.svg",
    questionnaire: ["Residency", "HouseholdSize", "IncomeLevel", "Insurance"],
    group: 0,
    hidden: [],
    householdIncomeQuestion: 2,
    eligibleIncomeGuide: 3
  },
  {
    name: "imdelltra",
    logo: "imdelltra.svg",
    questionnaire: ["Residency", "HouseholdSize", "IncomeLevel", "Insurance"],
    group: 0,
    hidden: [],
    householdIncomeQuestion: 1,
    eligibleIncomeGuide: 5
  },
  {
    name: "imlygic",
    logo: "imlygic.svg",
    questionnaire: ["Residency", "HouseholdSize", "IncomeLevel", "Insurance"],
    group: 0,
    hidden: [],
    householdIncomeQuestion: 1,
    eligibleIncomeGuide: 5
  },
  {
    name: "kyprolis",
    logo: "kyprolis.svg",
    questionnaire: ["Residency", "HouseholdSize", "IncomeLevel", "Insurance"],
    group: 0,
    hidden: [],
    householdIncomeQuestion: 1,
    eligibleIncomeGuide: 5
  },
  {
    name: "lumakras",
    logo: "lumakras.svg",
    questionnaire: ["Residency", "HouseholdSize", "IncomeLevel", "Insurance"],
    group: 0,
    hidden: [],
    householdIncomeQuestion: 1,
    eligibleIncomeGuide: 3
  },
  {
    name: "nplate",
    logo: "nplate.svg",
    questionnaire: ["Residency", "HouseholdSize", "IncomeLevel", "Insurance"],
    group: 0,
    hidden: [],
    householdIncomeQuestion: 1,
    eligibleIncomeGuide: 5
  },
  {
    name: "otezla",
    logo: "otezla.svg",
    questionnaire: ["Residency", "HouseholdSize", "IncomeLevel", "Insurance"],
    group: 3,
    hidden: [],
    householdIncomeQuestion: 2,
    eligibleIncomeGuide: 3
  },
  {
    name: "parsabiv",
    logo: "parsabiv.svg",
    questionnaire: ["Residency", "HouseholdSize", "IncomeLevel", "Insurance"],
    group: 0,
    hidden: [],
    householdIncomeQuestion: 2,
    eligibleIncomeGuide: 3
  },
  {
    name: "prolia",
    logo: "prolia.svg",
    questionnaire: ["Residency", "HouseholdSize", "IncomeLevel", "Insurance"],
    group: 0,
    hidden: ["eligible", "contact"],
    householdIncomeQuestion: 2,
    eligibleIncomeGuide: 3
  },
  {
    name: "repatha",
    logo: "repatha.svg",
    questionnaire: ["Residency", "HouseholdSize", "IncomeLevel", "Coverage"],
    group: 3,
    hidden: [],
    householdIncomeQuestion: 2,
    eligibleIncomeGuide: 3
  },
  {
    name: "tezspire",
    logo: "tezspire.svg",
    questionnaire: ["Residency", "HouseholdSize", "IncomeLevel", "Insurance"],
    group: 0,
    hidden: [],
    householdIncomeQuestion: 1,
    eligibleIncomeGuide: 5
  },
  {
    name: "tavneos",
    logo: "tavneos.svg",
    questionnaire: ["Residency", "HouseholdSize", "IncomeLevel", "Insurance"],
    group: 0,
    hidden: [],
    householdIncomeQuestion: 1,
    eligibleIncomeGuide: 3
  },
  {
    name: "vectibix",
    logo: "vectibix.svg",
    questionnaire: ["Residency", "HouseholdSize", "IncomeLevel", "Insurance"],
    group: 0,
    hidden: [],
    householdIncomeQuestion: 1,
    eligibleIncomeGuide: 5
  },
];
